/**
 * Translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancelar',
    CONFIRM: 'Confirmar',
    SAVE: 'Gravar'
  },
  ERROR: {},
  HEADER: {
    LINK: 'Link',
    SOCIAL_NETWORK: 'Rede social',
    USERNAME: 'Nome de utilizador'
  },
  LABEL: {
    CREATE_LINK: 'Adicionar rede social',
    EDIT_LINK: 'Editar rede social',
    INACTIVATE_LINK: 'Eliminar rede social',
    INACTIVATE_LINK_MODAL_TITLE: 'Eliminar rede social',
    LINK: 'Link',
    SOCIAL_NETWORK: 'Rede social',
    USERNAME: 'Nome de utilizador'
  },
  SENTENCE: {
    ERROR: 'Erro',
    INACTIVATE_LINK_TEXT: 'Tem a certeza que deseja eliminar a rede social?',
    NO_ROWS_LINKS: 'Sem redes sociais'
  },
  SUCCESS: {
    LINKS_DETAILS_INACTIVATE: 'Rede social eliminada com sucesso',
    LINKS_DETAILS_SAVED: 'Rede social guardada com sucesso',
    LINKS_DETAILS_UPDATED: 'Rede social atualizada com sucesso',
    SUCCESS: 'Sucesso'
  },
  TOOLTIP: {
    LINK: 'Link',
    SOCIAL_NETWORK: 'Rede social',
    USERNAME: 'Nome de utilizador'
  }
};
